var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAac(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56 56",
    style: {
      enableBackground: "new 0 0 56 56"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e9e9e0"
    },
    d: "M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#d9d7ca"
    },
    points: "37.5,0.151 37.5,12 49.349,12"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e57e25",
      fillOpacity: 1
    },
    d: "M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c8bdb8"
    },
    d: "M35.67,14.986c-0.567-0.796-1.3-1.543-2.308-2.351c-3.914-3.131-4.757-6.277-4.862-6.738V5 c0-0.553-0.447-1-1-1s-1,0.447-1,1v1v8.359v9.053h-3.706c-3.882,0-6.294,1.961-6.294,5.117c0,3.466,2.24,5.706,5.706,5.706 c3.471,0,6.294-2.823,6.294-6.294V16.468l0.298,0.243c0.34,0.336,0.861,0.72,1.521,1.205c2.318,1.709,6.2,4.567,5.224,7.793 C35.514,25.807,35.5,25.904,35.5,26c0,0.43,0.278,0.826,0.71,0.957C36.307,26.986,36.404,27,36.5,27c0.43,0,0.826-0.278,0.957-0.71 C39.084,20.915,37.035,16.9,35.67,14.986z M26.5,27.941c0,2.368-1.926,4.294-4.294,4.294c-2.355,0-3.706-1.351-3.706-3.706 c0-2.576,2.335-3.117,4.294-3.117H26.5V27.941z M31.505,16.308c-0.571-0.422-1.065-0.785-1.371-1.081l-1.634-1.34v-3.473 c0.827,1.174,1.987,2.483,3.612,3.783c0.858,0.688,1.472,1.308,1.929,1.95c0.716,1.003,1.431,2.339,1.788,3.978 C34.502,18.515,32.745,17.221,31.505,16.308z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "13.75px",
      fontFamily: "Allerta",
      InkscapeFontSpecification: "Allerta",
      fill: "#fff",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 14.25,52.495117 3.464355,-9.882812 1.597901,0 3.4375,9.882812 -1.665039,0 -0.71167,-2.054443 -3.719483,0 -0.725097,2.054443 -1.678467,0 z m 2.779541,-3.14209 2.954102,0 -1.463623,-4.270019 -1.490479,4.270019 z",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 24.455078,52.495117 3.464356,-9.882812 1.5979,0 3.4375,9.882812 -1.665039,0 -0.71167,-2.054443 -3.719482,0 -0.725098,2.054443 -1.678467,0 z m 2.779541,-3.14209 2.954102,0 -1.463623,-4.270019 -1.490479,4.270019 z",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 41.75,51.488037 q -0.550537,0.537109 -1.248779,0.805664 -0.698242,0.268555 -1.503907,0.268555 -0.88623,0 -1.638183,-0.322266 -0.738526,-0.322265 -1.30249,-0.953369 Q 35.506104,50.655518 35.183838,49.702148 34.875,48.748779 34.875,47.5 q 0,-1.248779 0.308838,-2.188721 0.322266,-0.953369 0.872803,-1.584472 0.563964,-0.631104 1.315918,-0.95337 0.751953,-0.335693 1.624755,-0.335693 0.805665,0 1.503907,0.268555 0.698242,0.268555 1.248779,0.805664 l -1.114502,0.993652 q -0.335693,-0.389404 -0.751953,-0.563965 -0.402832,-0.17456 -0.845947,-0.17456 -0.496827,0 -0.953369,0.187988 -0.443116,0.187988 -0.805665,0.644531 -0.349121,0.443116 -0.550537,1.154786 -0.201416,0.711669 -0.214843,1.745605 0.01343,1.00708 0.201416,1.71875 0.201416,0.71167 0.537109,1.168213 0.349121,0.443115 0.778809,0.657959 0.443115,0.201416 0.926513,0.201416 0.483399,0 0.899658,-0.174561 0.429688,-0.17456 0.778809,-0.563965 L 41.75,51.488037 Z",
    style: {}
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAac);
export default __webpack_public_path__ + "static/media/aac.aff963bd256df8cf58cb739a49e6f469.svg";
export { ForwardRef as ReactComponent };